import React from 'react'
import { EnlaceBase, useDiseñoConfig } from './ComponenteBase'

const DiseñoCard = ({ 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {}
}) => {
  // Obtener configuración del diseño
  const config = useDiseñoConfig('card', configuracion)

  // Ajustar para estilos miniatura
  if (estilosMiniatura) {
    return (
      <div className="space-y-1">
        {enlaces.map((enlace, index) => (
          <EnlaceBase
            key={enlace.id || index}
            enlace={enlace}
            estilosMiniatura={estilosMiniatura}
            esPreview={esPreview}
            configuracion={{
              ...config,
              // Ajustes específicos para miniatura
              tamañoIcono: 'pequeño',
              tema: 'card'
            }}
            className="enlace-miniatura"
          />
        ))}
      </div>
    )
  }

  // Diseño normal para desktop
  return (
    <div className="space-y-3 sm:space-y-4">
      {enlaces.map((enlace, index) => (
        <EnlaceBase
          key={enlace.id || index}
          enlace={enlace}
          estilosMiniatura={estilosMiniatura}
          esPreview={esPreview}
          configuracion={config}
          className="group"
        />
      ))}
    </div>
  )
}

export default DiseñoCard 